
// import { useGetProspectoByIdProspecto } from "@/shared/actions/erp";
import { LoaderComponent } from "@/shared/components/ui";
import { useParams } from "react-router-dom";
import AddMaterialFactibilidadCorporativoPage from "../../shared/add_solicitud_factibilidad_corporativo/AddMaterialFactibilidadCorporativoPage";
import { useCheckPermissions } from "@/shared";
import { PermissionsEnum } from "@/auth/interfaces";
import { fetchGetByIdPreventasCorporativos } from "@/shared/actions/erp/preventa_corporativo/preventa_corporativo.action";

export default function ViewPreFactibilidadCorporativoPage() {

  useCheckPermissions(PermissionsEnum.api_view_preventacoorporativa);

  const { idpreventacorporativa } = useParams();

  // const { data: dataProspecto, isLoading: isLoadingProspecto } = useGetProspectoByIdProspecto(idprospecto!);

  
  const { data: dataPreventaCorporativa, isLoading: isLoadingPreventaCorporativa } = fetchGetByIdPreventasCorporativos(idpreventacorporativa!)

  if (isLoadingPreventaCorporativa) return <LoaderComponent />

  if (!dataPreventaCorporativa) return null;

  return (
    <AddMaterialFactibilidadCorporativoPage
      title="Prefactibilidad Corporativa Aprobada"
      // dataProspecto={dataProspecto!}
      dataPreventa={dataPreventaCorporativa.data!}
      updateFactibilidad={false}
      showSaveButton={false}
      DISABLE_FIELD={true}
    />
  );


}